/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@glu/theming';
import locale from '@glu/locale';
import { AccessibilityText } from '@glu/utilities-react';
import { CaretDownNextIcon } from '@glu/icons-react';
import { Button } from './Button';
import styles from './MenuActions.styles';
import registerDefaults from './themeDefaults';

registerDefaults();
const useStyles = createUseStyles(styles);

const MenuActions = ({ actions, ...rest }) => {
  const [isOpen, setIsOpen] = useState(false);
  const classes = useStyles(rest);
  return (
    actions.length === 1
      ? <Button className={classes.button} {...actions[0]} />
      : (
        <div className={classes.root}>
          <div className={classes.dropdown}>
            <button
              className={classes.dropdownButton}
              type="button"
              {...actions[0]}
              onClick={() => {
                setIsOpen(false);
                actions[0].onClick();
              }}
            >
              {actions[0].text}
            </button>
            <button
              className={classes.dropdownToggle}
              data-qa="dropdown-toggle"
              type="button"
              onClick={() => { setIsOpen(!isOpen); }}
            >
              <CaretDownNextIcon
                className={classes.icon}
                focusable={false}
              />
              <AccessibilityText>
                {locale.get('menuActions.moreActions')}
              </AccessibilityText>
            </button>
          </div>
          {isOpen && (
            <ul className={classes.dropdownMenu} data-qa="dropdown-menu">
              {actions.slice(1).map((action, index) => (
                <li key={index} className={classes.dropdownMenuItem}>
                  <button
                    className={classes.dropdownAction}
                    type="button"
                    onClick={() => {
                      setIsOpen(false);
                      action.onClick();
                    }}
                  >
                    {action.text}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )
  );
};

MenuActions.propTypes = {
  /** Array of actions for button menu */
  actions: PropTypes.arrayOf(PropTypes.shape({
    /** function to call on click of button */
    onClick: PropTypes.func,
    /** text of button */
    text: PropTypes.string
  })).isRequired
};

export default MenuActions;
